import { useMemo } from "react";
import cn from "classnames";
import { SeaSearchCardModel } from "entities/SeaSearchCard";
import { Nullable } from "shared/lib/typeCheck.lib";
import { useTranslation } from "shared/localization/localization";
import styles from "./Demurrage.module.scss";

import { DemurrageLink } from "../DemurageLink";

type DemurrageProps = {
  data: Nullable<SeaSearchCardModel>;
};

export const Demurrage: RFC<DemurrageProps> = ({ data }) => {
  const { t } = useTranslation();
  const demurrage = useMemo(() => data?.demurage, [data]);
  const hasDemurage = !!demurrage?.length;

  return (
    <div className={styles.demurrageWrapper}>
      {hasDemurage ? (
        <>
          <DemurrageLink className={styles.demurrage} />
          <ul>
            {demurrage.map((item, index) => (
              <li key={index + item.number}>
                <div className={cn(styles.row, styles.titleRow)}>
                  <div className={styles.col}>{item.number}</div>
                  <div className={styles.col}>{t("Free days")}</div>
                  <div className={styles.col}>{t("Days in charge")}</div>
                </div>
                <div className={styles.row}>
                  <div className={styles.col}>{t("Storage")}</div>
                  <div className={styles.col}>{item.charges.storage.free_days}</div>
                  <div className={styles.col}>{item.charges.storage.days_in_charge}</div>
                </div>
                <div className={styles.row}>
                  <div className={styles.col}>{t("Demurrage")}</div>
                  <div className={styles.col}>{item.charges.demurrage.free_days}</div>
                  <div className={styles.col}>{item.charges.demurrage.days_in_charge}</div>
                </div>
                <div className={styles.row}>
                  <div className={styles.col}>{t("Detention")}</div>
                  <div className={styles.col}>{item.charges.detention.free_days}</div>
                  <div className={styles.col}>{item.charges.detention.days_in_charge}</div>
                </div>
              </li>
            ))}
          </ul>
        </>
      ) : (
        <div className={styles.errorWrapper}>
          <div className={styles["not-available-bold"]}>{t("Demurrage data is not available for this shipment")}</div>
        </div>
      )}
    </div>
  );
};
